import React, { useRef, useState } from "react";
import { Button, Form, Input, Modal } from "antd";
import globalRequest from "../../utils/global/globalRequest";
import { useDispatch } from "react-redux";
import * as Apis from "../../utils/helper/enum";
import { changeLoader } from "../../redux/reducers/loader";
import toast from "react-hot-toast";

const Otp = ({ isOpen, onOk, onCancel, verifyComplateOrderOtp, orderDetailData }) => {

  const dispatch = useDispatch();
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  const [otpText, setOtpText] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");

  const handleInput = (e, index) => {
    const { value } = e.target;
    setErrorMsg("");
    // Update the otpText array with the new value
    setOtpText((prevOtpText) => {
      const updatedOtpText = [...prevOtpText];
      updatedOtpText[index] = value;
      return updatedOtpText.filter((text) => text !== "");
    });

    if (value.length === 1 && index < 3) {
      inputRefs[index + 1].current.focus();
    } else if (value.length === 1 && index === 3) {
      inputRefs[index].current.blur();
    }

    // Handle backspace behavior
    if (value === "") {
      if (index === 0) {
        // If backspace on the first input, clear all fields
        inputRefs.forEach((inputRef) => {
          if (inputRef.current) inputRef.current.value = "";
        });
        inputRefs[0].current.focus();
      } else if (index > 0) {
        // Move focus to the previous input on backspace
        inputRefs[index - 1].current.focus();
      }
    }
  };

  const submitOtp = async () => {
    if (otpText.length < 4) {
      setErrorMsg("Otp is required");
      return false;
    }

    let otp = otpText.join("").trim();

    // if (otp === "1234") {
    //   verifyComplateOrderOtp();
    // } else {
    //   setErrorMsg("Invalid Otp");
    // }

    dispatch(changeLoader(true));
    let response = await globalRequest(
      Apis?.ORDERS?.VERIFY_OTP,
      "post",
      { order_id: orderDetailData.id, otp: otp },
      {},
      true
    );
    let apiResponse = response?.data;
    if (response?.status === 200) {
      let msg = "Otp Verified";
      toast.success(msg, {
        duration: 2000,
      });
      verifyComplateOrderOtp();
    } else {
      toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));

  };

  return (
    <>
      <Modal
        title={
          <>
            <h1 className="font-bold">Verify Code</h1>
          </>
        }
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={onOk}
        footer={false}
      >
        <p className="font-normal">
          Enter the 4-digit code sent to customer mobile number{" "}
          <span className="text-black !font-semibold">
            +966-{orderDetailData?.userMobileNo}
          </span></p>
        <Form
          name="otp"
          layout="vertical"
          initialValues={{
            remember: true,
          }}
          style={{ marginTop: 24 }}
          autoComplete="off"
        >
          <h1 className="text-sm mb-1 font-medium">
            Code <span className="text-red-500">*</span>
          </h1>
          <div className="flex gap-3">
            {inputRefs.map((inputRef, index) => (
              <Input
                key={index}
                maxLength={1}
                size="large"
                className="h-[70px] text-center"
                ref={inputRef}
                onChange={(e) => handleInput(e, index)}
              />
            ))}
          </div>
          <div className="flex gap-3">
            {errorMsg ? <p>{errorMsg}</p> : null}
          </div>

          <Button
            className="bg-[#176b53] text-[#ffffff] rounded-full w-full h-[45px] mt-10"
            onClick={() => {
              submitOtp();
            }}
          >
            Verify
          </Button>
        </Form>
      </Modal>
    </>
  );
};

export default Otp;
